import { Domain as BingoDomain } from '@policyfly/protobuf/pfbingo'
import { Domain as InternalDomain } from '@policyfly/protobuf/pfinternal'

const bingoDomainToInternalDomainMap = new Map([
  [BingoDomain.DOMAIN_UNSPECIFIED, InternalDomain.DOMAIN_UNSPECIFIED],
  [BingoDomain.DOMAIN_ACCOUNTING, InternalDomain.DOMAIN_ACCOUNTING],
  [BingoDomain.DOMAIN_API, InternalDomain.DOMAIN_API],
  [BingoDomain.DOMAIN_CAPTURE, InternalDomain.DOMAIN_CAPTURE],
  [BingoDomain.DOMAIN_PF_CORE, InternalDomain.DOMAIN_PF_CORE],
])

export function bingoDomainToInternalDomain (bingo: BingoDomain): InternalDomain {
  return bingoDomainToInternalDomainMap.get(bingo) ?? InternalDomain.DOMAIN_UNSPECIFIED
}
